import { teamsAPI } from '@/lib/api';
import { NavigateFunction } from 'react-router-dom';

/**
 * Smart navigation that redirects users based on their team status
 * - If user has no teams: redirect to onboarding
 * - If user has teams: redirect to intended destination or dashboard
 */
export async function navigateAfterAuth(
  navigate: NavigateFunction, 
  intendedDestination: string = '/dashboard'
): Promise<void> {
  try {
    // Check if user has any teams
    const teamsResponse = await teamsAPI.getTeams();
    const teams = teamsResponse?.data;
    
    if (!teams || !Array.isArray(teams) || teams.length === 0) {
      // No teams - redirect to onboarding
      navigate('/onboarding', { replace: true });
    } else {
      // Has teams - redirect to intended destination
      navigate(intendedDestination, { replace: true });
    }
  } catch (error) {
    // If teams API fails, redirect to dashboard and let the app handle it
    console.warn('Could not check teams during navigation, defaulting to dashboard:', error);
    navigate(intendedDestination, { replace: true });
  }
}

/**
 * Get the appropriate redirect path based on team status
 * Used for location state and conditional redirects
 */
export async function getRedirectPath(defaultPath: string = '/dashboard'): Promise<string> {
  try {
    const teamsResponse = await teamsAPI.getTeams();
    const teams = teamsResponse?.data;
    
    if (!teams || !Array.isArray(teams) || teams.length === 0) {
      return '/onboarding';
    }
    
    return defaultPath;
  } catch (error) {
    console.warn('Could not check teams for redirect path:', error);
    return defaultPath;
  }
}